/**
 * The largest student message the tutor accepts, in characters (~5,000 tokens).
 *
 * Set from the first TME 310 export (Oct 2026): a typical message is ~100 characters,
 * the longest legitimate code pasted for review was ~14,000, and the smallest pasted
 * data file was ~73,000 (the largest, 559,000 — about 300k tokens and ~$1 per reply).
 * 16 such pastes were about a third of the term's spend, and they are what pushed
 * conversations into the per-conversation token limit.
 *
 * The server enforces it; the widget and web chat use the same number to say so before
 * the student sends.
 */
export const MAX_MESSAGE_CHARS = 20_000;

/** What a student is told when a message is over the limit. */
export function tooLongMessage(length: number): string {
  return (
    `That message is too long to send (${length.toLocaleString()} of ` +
    `${MAX_MESSAGE_CHARS.toLocaleString()} characters). If you pasted a data file, paste just ` +
    `the part you're asking about — for example the channel header or a few lines.`
  );
}
